module.exports = __webpack_public_path__ + "assets/img/25_387_big.42894793.jpg";